var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-container__gallery-container"},[(_vm.photos.length > 0)?_c('v-owl-carousel',{attrs:{"margin":"30","responsive":{
      0:{items:1,nav:false,dots:false},
      768:{items:2,nav:true,dots:false},
      1200:{items:2,nav:true,dots:false}
    }}},_vm._l((_vm.photos),function(photo,index){return _c('a',{key:index,staticClass:"fancybox-img company-photo-gallery__image",style:(_vm.backgroundImage(photo)),attrs:{"href":photo.file_path,"data-fancybox":"fancybox-gallery"}})}),0):_vm._e()],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd8af62e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/company/PhotoGallery.vue
// module id = lQRn
// module chunks = 36